
import { defineComponent, PropType } from 'vue';

import IconCheck from '@white-label-icon/icon-check';

import { ReceiptPageHeadPreloader } from 'ecommerce/feature-receipt-header';

export default defineComponent({
  name: 'ManageBookingReceiptInfoHeader',

  components: {
    IconCheck,
    ReceiptPageHeadPreloader
  },

  props: {
    title: {
      type: String as PropType<string | VueI18n.TranslateResult>,
      default: '',
    },

    subtitle: {
      type: String as PropType<string | VueI18n.TranslateResult>,
      default: '',
    },

    contentLoading: {
      type: Boolean,
    },
  },
});
